import { localStg } from '@/utils';

/** 获取系统标题 */
export function getSystemTitle() {
  return localStg.get('systemTitle') || '后台管理系统';
}

/** 获取token */
export function getToken() {
  return localStg.get('token') || '';
}

/** 获取用户信息 */
export function getUserInfo() {
  const emptyInfo = {} as ApiAccount.AdminUserInfo;
  const userInfo: ApiAccount.AdminUserInfo = localStg.get('userInfo') || emptyInfo;

  return userInfo;
}

/** 获取水印 */
export function getWatermark() {
  return localStg.get('watermark') || '';
}

/** 去除用户相关缓存 */
export function clearAuthStorage() {
  localStg.remove('token');
  localStg.remove('userInfo');
  localStg.remove('isLockScreen');
}
